import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'prism-view-image-dialog',
  templateUrl: './view-image-dialog.component.html',
  styleUrls: ['./view-image-dialog.component.scss'],
})

export class ViewImageDialogComponent implements OnInit {


  @Input() args!: {imageDownloadUrl: string}


  constructor(
  ) { }

  ngOnInit(): void {
  }


}